import { useState } from "react";
import { Button, Col, Modal, Row, Space, Typography, message } from "antd";
import { SearchQuery } from "../code/search-query/search-query";
import { getAnswersExport } from "../repository/data.repository";
import Loader from "../controls/Loader";
import AnswersView from "../components/answers/AnswersView";
import { Answer } from "../repository/data.default";
import AnswerFormDialog from "../components/answers/AnswerFormDialog";
import { Guid } from "guid-typescript";
import { getProblemMessage } from "../utils/http";
import { useSelector } from "../store/store";
import { authorizeSelectors } from "../store/authorize";

function AnswersPage() {
  const permissions = useSelector(authorizeSelectors.permissions);
  const [modal, contextHolder] = Modal.useModal();
  const [searchQuery, setSearchQuery] = useState<SearchQuery>({
    conditions: [],
  });
  const [answerInputValues, setAnswerInputValues] =
      useState<Answer>({} as any);
  const [answerInputOpen, setAnswerInputOpen] = useState(false);
  const [answerInputMode, setAnswerInputMode] = useState<
    "view" | "delete"
  >("view");
  const [triggerView, setTriggerView] = useState(Guid.create().toString());

  // Events

  function onSearch(searchQuery: SearchQuery): void {
    setSearchQuery(searchQuery);
  }

  function onAnswerInputOpen(
    mode:  "view" | "delete",
    values: Answer,
  ): void {
    setAnswerInputOpen(true);
    setAnswerInputValues(
      values
        ? values
        : ({} as any),
    );
    setAnswerInputMode(mode);
  }

  function onAnswerFormFinish(){
    setAnswerInputOpen(false);
    setAnswerInputValues({} as any);
    setTriggerView(Guid.create().toString());
  }

  function onAnswerClose(): void {
    setAnswerInputOpen(false);
  }

  function onDownloadExport(): void {
    const loading = modal.info({
      content: (
        <Typography.Text className="m-1 ml-2 inline-block">
          Downloading answers export file..
        </Typography.Text>
      ),
      footer: null,
      centered: true,
      icon: <Loader />,
    });

    getAnswersExport({
      searchQuery,
      pageNumber: 0,
      pageSize: Number.MAX_SAFE_INTEGER,
    })
      .then(() => {
        loading.destroy();
      })
      .catch((err) => {
        loading.destroy();
        message.error(getProblemMessage(err) || "Failed to download export.");
      });
  }

  return (
    <Col className="relative flex flex-auto flex-col overflow-hidden overflow-y-auto">
      <Row className="sticky top-0 z-10 flex flex-row flex-wrap items-center p-4">
        <Typography.Title className="m-0 flex-auto" level={4}>
          Answers
        </Typography.Title>
        <Space className="flex flex-row">
          <Button
            type="primary"
            disabled={!permissions.can("QuestionnairesAnswers", "view")}
            onClick={() => onDownloadExport()}
          >
            Export to Excel
          </Button>
        </Space>
      </Row>
      <Col className="flex flex-auto flex-col overflow-hidden p-4 pb-4 pt-0">
        <AnswersView
          onSearch={onSearch}
          trigger={triggerView}
          onAction={(key: string, record: any) =>
            onAnswerInputOpen(key as any, record)
          }
        />
      </Col>
      <AnswerFormDialog
        open={answerInputOpen}
        mode={answerInputMode}
        initialValues={answerInputValues}
        onCancel={onAnswerClose}
        onFinish={onAnswerFormFinish}
      />
      {contextHolder}
    </Col>
  );
}

export default AnswersPage;
